import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';
import { useMemo } from 'react';
import { titleCaseSentence } from '@/utils';

export const useComponentGroupTitles = () => {
  const assemblyTemplate = useAtomValue(state.assemblyTemplate);

  const groupTitles = useMemo(() => {
    if (!assemblyTemplate?.assessmentDetails) return [];

    const groupTypes = new Set<string>();
    for (const detail of assemblyTemplate.assessmentDetails || []) {
      if (detail.isVisible) {
        groupTypes.add(detail.type);
      }
    }

    return Array.from(groupTypes).map((type) => ({
      id: type,
      title: titleCaseSentence(type.replace(/_/g, ' ')),
    }));
  }, [assemblyTemplate?.assessmentDetails]);

  return groupTitles;
};
